export const TEE_TIME_POLL_COURSES_INTERACTION_CLASS = 'shepherd-tee-time-poll-courses-interaction';

export function setTeeTimePollCoursesInteractionActive(active: boolean): void {
  document.body.classList.toggle(TEE_TIME_POLL_COURSES_INTERACTION_CLASS, active);
}

export function resolveTeeTimePollCoursesTarget(): HTMLElement | null {
  return document.querySelector('[data-tour="tee-time-poll-golf-courses"]');
}

export function resetTeeTimePollCoursesTargetPadding(): void {
  const root = resolveTeeTimePollCoursesTarget();
  if (root) {
    root.style.paddingBottom = '';
  }
}
